/**
 * Reducer to control the sidebar status.
 */

type State = { open: boolean };

type Action = { type: 'global_sidebar/toggle' };

const initialState: State = { open: false };

export const reducer = (state = initialState, action: Action): State => {
    switch (action.type) {
        case 'global_sidebar/toggle':
            return { ...state, open: !state.open };
        default:
            return state;
    }
};

/**
 * Toggle the sidebar open status.
 */
const toggle = (): Action => ({ type: 'global_sidebar/toggle' });

export const creators = { toggle };
